import { DataCompletenessEnum } from "@flexidao/dto";

export const formatDataCompleteness = (dataCompleteness: DataCompletenessEnum): string => {
    switch (dataCompleteness) {
        case DataCompletenessEnum.AllDataReceived:
            return "All data received";
        case DataCompletenessEnum.PartialDataReceived:
            return "Partial data received";
        case DataCompletenessEnum.NoDataReceived:
            return "No data received";
    }
};
